import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import homepage from '@/components/homepage'
import login from '@/components/login'
import enlist from '@/components/enlist'
import enlistDetail from '@/components/enlistDetail'
import sale from '@/components/sale'
import saleDetail from '@/components/saleDetail'
import my from '@/components/my'
import search from '@/components/search'
import detail from '@/components/detail'
Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      name: 'homepage',
      component: homepage
    },
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/enlist',
      name: 'enlist',
      component: enlist
    },
    {
      path: '/enlistDetail',
      name: 'enlistDetail',
      component: enlistDetail
    },
    {
      path: '/sale',
      name: 'sale',
      component: sale
    },
    {
      path: '/saleDetail',
      name: 'saleDetail',
      component: saleDetail
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/my',
      name: 'my',
      component: my
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js